import React from "react";
import { motion } from "framer-motion";
import { Play, Music, Waves, Hand } from "lucide-react";

const MODULES = [
  {
    n: "01",
    icon: Play,
    label: "Texte d'ouverture émotionnel",
    title: "La salle des miroirs",
    blurb:
      "un texte parlé pour rencontrer la voix qui décide à ta place — sans lui obéir.",
    duration: "≈ 8 min",
  },
  {
    n: "02",
    icon: Music,
    label: "Chanson d'activation",
    title: "Je n'ai plus à prouver ma lumière",
    blurb:
      "un ancrage émotionnel et hypnotique. mots, images, vibration — comme un parfum intérieur.",
    duration: "≈ 4 min",
  },
  {
    n: "03",
    icon: Waves,
    label: "Piste immersive d'intégration",
    title: "Retour à ma place",
    blurb:
      "une séance sonore guidée pour déposer le mental et revenir dans ton axe corporel.",
    duration: "≈ 18 min",
  },
  {
    n: "04",
    icon: Hand,
    label: "Mini-pratique d'ancrage",
    title: "L'acte de légitimité",
    blurb:
      "un protocole simple en 5 minutes — pour transformer le ressenti en geste concret.",
    duration: "≈ 5 min",
  },
];

export default function WhatsInside() {
  return (
    <section
      data-testid="whats-inside-section"
      id="contenu"
      className="relative py-24 md:py-36 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-20">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            03 · L'expérience
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Ce que tu{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              reçois
            </span>
            .
          </h2>
          <p className="mt-6 font-serif italic text-lg md:text-xl text-ink-400 max-w-xl lowercase">
            quatre pistes — une porte d'entrée par sens, une par couche
            intérieure.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {MODULES.map((m, idx) => (
            <motion.article
              key={m.n}
              data-testid={`module-card-${idx}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: idx * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group relative bg-obsidian-surface border border-white/[0.06] rounded-2xl p-8 md:p-10 hover:border-gold/40 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
            >
              <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-gold/[0.04] blur-3xl group-hover:bg-gold/[0.08] transition-all" />

              <div className="relative flex items-start justify-between gap-6 mb-10">
                <span className="font-display text-6xl md:text-7xl text-gold/30 leading-none tracking-tighter">
                  {m.n}
                </span>
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center bg-gold/5 group-hover:bg-gold/10 transition-colors">
                  <m.icon className="w-5 h-5 text-gold" />
                </div>
              </div>

              <div className="relative">
                <p className="text-[11px] tracking-[0.25em] uppercase text-ink-400 mb-3">
                  {m.label}
                </p>
                <h3 className="font-display text-2xl md:text-3xl text-ink-50 mb-4 tracking-tight">
                  {m.title}
                </h3>
                <p className="font-serif italic text-ink-400 text-lg leading-relaxed lowercase">
                  {m.blurb}
                </p>
                <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-end text-xs uppercase tracking-[0.2em] text-ink-400">
                  <span className="text-gold/80">audio · mp3</span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
